import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import { LogIn, LogOut, ShieldCheck, Sparkles, User as UserIcon, Gift } from "lucide-react";

export default function Header() {
  const { user, login, logout } = useAuth();
  const navigate = useNavigate();

  // Admin nunca fica em Header — é redireccionado para /admin (isolado, sem
  // este Header) assim que a sessão carrega. Este nav só serve jogadores.
  const nav = [
    { to: "/sorteio", label: "Sorteio" },
    { to: "/premios", label: "Prémios" },
    { to: "/minha-conta", label: "Minha Conta", auth: true },
  ];

  return (
    <header className="fixed w-full top-0 z-50 backdrop-blur-xl" style={{background: "rgba(10,16,13,0.78)", borderBottom: "1px solid var(--border)"}}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-home-link">
          <Sparkles size={20} className="text-gold" />
          <span className="font-display text-xl md:text-2xl tracking-wide">Triunfo de <span className="text-gold">Gaia</span></span>
        </Link>
        <nav className="hidden md:flex items-center gap-2">
          {nav.filter(n => !n.admin || user?.is_admin).filter(n => !n.auth || user).map(n => (
            <NavLink key={n.to} to={n.to} data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}
              className={({isActive}) => `px-4 py-2 rounded-md text-sm transition-colors ${isActive ? "text-gold" : "text-[color:var(--text-2)] hover:text-[color:var(--text)]"}`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <div className="flex items-center gap-3">
              {user.is_admin && <span title="Admin" className="text-gold"><ShieldCheck size={18} /></span>}
              <button onClick={() => navigate(user.is_admin ? "/admin" : "/minha-conta")} className="flex items-center gap-2 px-3 py-1.5 rounded-md hover:bg-white/5" data-testid="header-user-button">
                {user.picture ? (
                  <img src={user.picture} alt="" className="w-7 h-7 rounded-full border border-gold/40" />
                ) : <UserIcon size={18} />}
                <span className="text-sm hidden md:inline">{user.name?.split(" ")[0]}</span>
                {!user.is_admin && (
                  <span className="hidden md:flex items-center gap-1 text-xs text-gold border border-gold/40 px-2 py-0.5 rounded-full">
                    <Gift size={12} />{(user.voucher_balance ?? 0).toFixed(2)}€
                  </span>
                )}
              </button>
              <button onClick={logout} className="text-[color:var(--text-2)] hover:text-gold p-2" data-testid="logout-button" title="Sair">
                <LogOut size={18} />
              </button>
            </div>
          ) : (
            <button onClick={login} className="btn-primary !py-2 !px-4 text-sm flex items-center gap-2" data-testid="login-button">
              <LogIn size={16} /> Entrar
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
